App.namespace('debug', () => {
  return window.DEBUG || App.es6.shared.cookie.get('DEBUG') || false;
});
